import React from 'react';

const WatcherCardBack = () => {
  return (
    <div className="card-back watcher-card-back">
      <div className="watcher-icon">👁️</div>
    </div>
  );
};

export default WatcherCardBack;
